import React from "react";
import DashboardHeader from "../DashboardHeader";
import { Navigate, Outlet, useLocation } from "react-router-dom";
import { useAuth } from "../../contexts/AuthContext";
import DashboardSidebar from "../DashboardSidebar";
import ProfileSidebar from "../ProfileSidebar";

const DashboardLayout = () => {
  const { user } = useAuth();
  const location = useLocation();
  const {pathname = ""} = location;

  if (!user?.access_token) {
    return <Navigate to="/login" />;
  }
  // let isSapActive = pathname == "/sap-reports"
  let isSapActive = false
  let isVoucherDownload = pathname == "/voucher-reports"
  return (
    <div className="dashboard-layout-container">
      <DashboardSidebar />
      <ProfileSidebar />
      <div className="layout-container">
        <DashboardHeader isSapActive={isSapActive} isVoucherDownload={isVoucherDownload} />
        <div className="content-container">
          <Outlet />
        </div>
      </div>
    </div>
  );
};

export default DashboardLayout;
